import React from "react";

export default function MoreMenu(props) {

    return (
        <div className="ui5-popover-menu" style={{width: 170}}>

            <div className={Classes("option", "with-icon", {disabled: !props.menuParams.onMoveRight})}
                 onClick={!props.menuParams.onMoveRight ? null : ()=>{props.hidePopover(); props.menuParams.onMoveRight();}}>
                <div className="ico i5-long-arrow-right"/>
                <div className="label">Move right</div>
            </div>

            <div className={Classes("option", "with-icon", {disabled: !props.menuParams.onMoveLeft})}
                 onClick={!props.menuParams.onMoveLeft ? null : ()=>{props.hidePopover(); props.menuParams.onMoveLeft();}}>
                <div className="ico i5-long-arrow-left"/>
                <div className="label">Move left</div>
            </div>

            <div className={Classes("option", "with-icon", {disabled: !props.menuParams.onResetColumnWidth})}
                 onClick={()=>{props.hidePopover(); props.menuParams.onResetColumnWidth();}}>
                <div className="ico i5-reset-columns"/>
                <div className="label">Reset width</div>
            </div>

            <div className={Classes("option", "with-icon", {disabled: !props.menuParams.onRemoveColumn})}
                 onClick={!props.menuParams.onRemoveColumn ? null : ()=>{props.hidePopover(); props.menuParams.onRemoveColumn();}}>
                <div className="ico i5-trash-alt"/>
                <div className="label">Remove column</div>
            </div>
        </div>
    );
}